export const FALLBACK_IMAGE =
  'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 150"><rect width="150" height="150" fill="%23f3f4f6"/><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="%239ca3af" font-size="16" font-family="Arial, sans-serif">No Image</text></svg>'

export const applyFallbackIfNeeded = (event) => {
  const img = event.currentTarget
  if (img.src !== FALLBACK_IMAGE) {
    img.src = FALLBACK_IMAGE
  }
}
